import styled, { css } from 'styled-components';
import { setSvgColor, flexCenter } from 'styles/mixins';

export const Container = styled.button`
  width: 48px;
  height: 48px;

  display: flex;
  flex-shrink: 0;
  overflow: hidden;

  border: none;
  outline: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    width: 30%;
    height: 30%;
  }

  ${({ theme }) => css`
    ${flexCenter};
    ${setSvgColor(theme.colors.lightGrey.main)};
    background-color: ${theme.colors.grey.hover};

    &:hover:enabled {
      opacity: 0.5;
      cursor: pointer;
    }

    &:active:enabled {
      opacity: 0.3;
      cursor: pointer;
    }
  `}
`;
